export default {
  name: 'oTitle'
};
